"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgress = exports.ProgressText = exports.ProgressSuccessBg = exports.ProgressOuter = exports.ProgressLabel = exports.ProgressInner = exports.ProgressBg = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ProgressOuter = exports.ProgressOuter = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-y9s9d7-0"
})([""]);
var ProgressInner = exports.ProgressInner = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-y9s9d7-1"
})([""]);
var ProgressBg = exports.ProgressBg = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-y9s9d7-2"
})([""]);
var ProgressSuccessBg = exports.ProgressSuccessBg = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-y9s9d7-3"
})([""]);
var ProgressText = exports.ProgressText = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-y9s9d7-4"
})([""]);
var ProgressLabel = exports.ProgressLabel = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-y9s9d7-5"
})(["word-break:normal;position:absolute;top:-50%;font-size:", ";font-weight:", ";color:", ";line-height:", ";", " ", ""], function (props) {
  return props.theme.progress.labelText.fontSize;
}, function (props) {
  return props.theme.progress.labelText.fontWeight;
}, function (props) {
  return props.theme.progress.textColor;
}, function (props) {
  return props.theme.progress.labelText.lineHeight;
}, function (props) {
  return props.leftLabelText && (0, _ykbStyledComponents.css)(["left:", ";"], function (props) {
    return props.theme.progress.labelText.left;
  });
}, function (props) {
  return props.rightLabelText && (0, _ykbStyledComponents.css)(["right:", ";"], function (props) {
    return props.$showInfo ? props.theme.progress.labelText.right : '0px';
  });
});
var ykbProgressActive = (0, _ykbStyledComponents.keyframes)(["0%{opacity:0.1;width:0;}20%{opacity:0.5;width:0;}100%{opacity:0;width:100%;}"]);
var StyledProgress = exports.StyledProgress = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-y9s9d7-6"
})(["display:inline-block;", " ", " ", "{display:inline-block;width:100%;margin-right:0;padding-right:0;}", " ", "{display:inline-block;width:100%;background-color:", ";border-radius:100px;vertical-align:middle;position:relative;}&-circle-trail{stroke:", ";}&-circle-path{stroke:", ";animation:'ykb-progress-appear' 0.3s;}", ",", "{border-radius:100px;background-color:", ";transition:all 0.4s ", " 0s;position:relative;}", "{background-color:", ";position:absolute;top:0;left:0;}", "{word-break:normal;width:2em;text-align:left;font-size:1em;margin-left:8px;vertical-align:middle;display:inline-block;color:", ";line-height:1;.ykb-icon{font-size:", ";}}", " ", " ", " ", ""], function (props) {
  return props.$type && (props.$type === 'line' && (0, _ykbStyledComponents.css)(["width:100%;font-size:", ";position:relative;"], function (props) {
    return props.theme.font.size;
  }) || (0, _ykbStyledComponents.css)([""]));
}, function (props) {
  return props.$size && props.$type && props.$size === 'small' && props.$type === 'line' && (0, _ykbStyledComponents.css)(["font-size:", ";", "{.ykb-icon{font-size:", ";}}"], function (props) {
    return props.theme.font.sizeSm;
  }, ProgressText, function (props) {
    return props.theme.font.sizeSm;
  });
}, ProgressOuter, function (props) {
  return props.$showInfo && (0, _ykbStyledComponents.css)(["", "{padding-right:", ";margin-right:", ";}"], ProgressOuter, function (props) {
    return props.theme.progress.paddingRight;
  }, function (props) {
    return props.theme.progress.marginRight;
  });
}, ProgressInner, function (props) {
  return props.theme.progress.remainingColor;
}, function (props) {
  return props.theme.progress.remainingColor;
}, function (props) {
  return props.theme.progress.defaultColor;
}, ProgressSuccessBg, ProgressBg, function (props) {
  return props.theme.progress.defaultColor;
}, function (props) {
  return props.theme.animation.ease.outCirc;
}, ProgressSuccessBg, function (props) {
  return props.theme.color.success6;
}, ProgressText, function (props) {
  return props.theme.progress.textColor;
}, function (props) {
  return props.theme.font.size;
}, function (props) {
  return props.$progressStatus == 'active' && (0, _ykbStyledComponents.css)(["", ":before{content:'';opacity:0;position:absolute;top:0;left:0;right:0;bottom:0;background:", ";border-radius:10px;animation:ykbProgressActive 2.4s ", " infinite;}"], ProgressBg, function (props) {
    return props.theme.progress.activeBackground;
  }, function (props) {
    return props.theme.animation.ease.outQuint;
  });
}, function (props) {
  return props.$progressStatus == 'exception' && (0, _ykbStyledComponents.css)(["", "{background-color:", ";}", "{color:", ";}[class*='-circle-path']{stroke:", ";}"], ProgressBg, function (props) {
    return props.theme.progress.errorColor;
  }, ProgressText, function (props) {
    return props.$strokeColor || props.theme.progress.errorColor;
  }, function (props) {
    return props.theme.progress.errorColor;
  });
}, function (props) {
  return props.$progressStatus == 'success' && (0, _ykbStyledComponents.css)(["", "{background-color:", ";}", "{color:", ";}[class*='-circle-path']{stroke:", ";}"], ProgressBg, function (props) {
    return props.theme.progress.successColor;
  }, ProgressText, function (props) {
    return props.$strokeColor || props.theme.progress.successColor;
  }, function (props) {
    return props.theme.progress.successColor;
  });
}, function (props) {
  return props.$type != 'line' && (0, _ykbStyledComponents.css)(["", "{position:relative;line-height:1;background-color:transparent;}", "{display:block;position:absolute;width:100%;text-align:center;line-height:1;top:50%;transform:translateY(-50%);left:0;margin:0;color:", ";.ykb-icon{font-size:14 / 12em;}}", " ", ""], ProgressInner, ProgressText, function (props) {
    return props.theme.progress.textColor;
  }, function (props) {
    return props.$progressStatus == 'exception' && (0, _ykbStyledComponents.css)(["", "{color:", ";}"], ProgressText, function (props) {
      return props.$strokeColor || props.theme.progress.errorColor;
    });
  }, function (props) {
    return props.$progressStatus == 'success' && (0, _ykbStyledComponents.css)(["", "{color:", ";}"], ProgressText, function (props) {
      return props.$strokeColor || props.theme.progress.successColor;
    });
  });
});